import environment from 'environment';
import { getSessionToken } from 'util/parseSelectors';
import request from 'util/superagent';
import RequestMonitor from 'util/requestMonitor';
import makeCloudFunctionRequest from '../makeCloudFunctionRequest';

/** ******* THE BELOW FUNCTIONS ARE RELATED TO SYSTEM-AGNOSTIC COMMON FUNCTIONS BUT THAT ARE NOT PART OF THE COMMON ORDER INTERFACE. DO NOT ADD ANOTHER FUNCTION TO THIS FILE UNLESS IT MEETS THOSE CRITERIA, WE PREFER TO USE COMMON ORDER INTERFACE OVER SHARED ENDPOINTS ******* **/

const { COMMON_ORDERS_BASE_URL } = environment.eCommerce;

export const commonOrdersPostQuery = async (
  api,
  query = {},
  payload = {},
  timeOut = 30000,
  uniqueRequestUuid = null
) => {
  const sessionToken = getSessionToken();
  const commonOrderRequest = request
    .post(`${COMMON_ORDERS_BASE_URL}${api}`)
    .timeout({
      response: timeOut,
      deadline: 60000,
    })
    .set('Accept', 'application/json')
    .set('Content-type', 'application/json')
    .set('x-session-token', sessionToken)
    .query(query)
    .send(payload);

  if (uniqueRequestUuid) {
    RequestMonitor.check(commonOrderRequest, uniqueRequestUuid);
  }

  return commonOrderRequest.then((response) => {
    return response.body;
  });
};

export const fetchCustomSellerOrdersByEmail = (simplrAccountId, email) => {
  return makeCloudFunctionRequest('fetchCustomSellerOrdersByEmail', {
    simplrAccountId,
    email,
  });
};
